
import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import { default as RigaDistintaInValidazione } from "./RigaDistintaInValidazione.vue";
import RigaDistintaListaVariazioni from './RigaDistintaListaVariazioni.vue';
import { DialogNewVariazione } from '@/components';
import VariazioniMassive from './VariazioniMassive.vue';
import ValidazioniMassive from './ValidazioniMassive.vue';
import { Distinta, RigaDistinta, StatoVariazioneRigaDistinta, VariazioneRigaDistinta, ComunicazioneVariazioneRigaDistinta, 
VariazioneDaComunicare, VariazioneDaComunicareQtaTaglia, TipoVariazione, StatoSyncRigaDistinta, RigaInValidazione, RigaDistintaQtaTaglia } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';

@Component({
    components: {
        RigaDistintaInValidazione,
        RigaDistintaListaVariazioni,
        DialogNewVariazione,
        VariazioniMassive,
        ValidazioniMassive        
    }
})
export default class RigheDistintaValidazioneConsumi extends Vue {
    
    get distinta(): Distinta | undefined { return store.state.distintaCorrente; }
    private StatoVariazione = StatoVariazioneRigaDistinta;
    private nuoveRighe:VariazioneDaComunicare[] = [];
    private righeInValidazione :RigaInValidazione[] = [];
    @Ref() private dialog! : DialogNewVariazione;

    get maxIndice(){
        if(this.distinta) return Math.max(...this.distinta.righeDistintaDPC.map((r: RigaDistinta) => r.indiceRiga)) ;
        return 0;
    }

    get righeConVariazioni(): RigaInValidazione[]
    {        
        let righe = this.righeInValidazione.filter(riga => riga.contieneVariazioniDaValidare);
        righe.forEach((r, i) => r.indiceRiga = parseInt(r.innerRigaDistinta.posizRiga)|| 0) ;
        return righe.sort((curr, prev) => curr.indiceRiga < prev.indiceRiga ? -1 : 0)        
    }

    get altreRighe(): RigaInValidazione[]
    {        
        let righe = this.righeInValidazione.filter(riga => !riga.contieneVariazioniDaValidare || riga.eliminataDaAs400);
        righe.forEach((r, i) => r.indiceRiga = parseInt(r.innerRigaDistinta.posizRiga)|| 0);
        return righe.sort((curr, prev) => curr.indiceRiga < prev.indiceRiga ? -1 : 0)        
    }

    get righeConVariazioniTutteEliminate(): boolean
    {
        return this.righeConVariazioni.every(r => r.eliminataDaAs400);
    }

    private dict: any = {};
    private righeEliminateBackupDict: any = {};
    private pannelliVariazioniAperti: number = -1;
    private pannelliAltreRigheAperti: number = -1;

    private editRiga(riga: RigaInValidazione) {
        riga.contieneVariazioniDaValidare = true;   
        riga.variazioneGenerataDaValidazione = true;             

        // chiudo gli accordion delle "altre righe" e imposto come aperto l'accordion panel
        // relativo alla riga che è stata appena messa in editing
        this.pannelliAltreRigheAperti = -1;
        this.pannelliVariazioniAperti = this.righeConVariazioni.indexOf(riga);
    }

    get contieneVariazioniDaInviare(): boolean {
        let ret = false;
        for (const key in this.dict) {
            if (this.dict.hasOwnProperty(key)) {
                const v: VariazioneRigaDistinta = this.dict[key];
                if(v._accettata) {
                    ret = true;
                    break;
                }
                for(const keyCorr in v.variazioniCorrelate){                    
                    if(v.variazioniCorrelate.hasOwnProperty(keyCorr)){
                        const vCorr: VariazioneRigaDistinta = v.variazioniCorrelate[keyCorr];
                        if(vCorr._accettata) {
                            ret = true;
                            break;
                        }
                    }
                }
            }
        }
        return ret;
    }
    private undoEliminazioneRiga(r: RigaInValidazione) {        
        if (this.dict.hasOwnProperty(r.id)) {
            Object.keys(this.dict[r.id].backupDict).forEach(k => {
                this.$delete(this.dict[r.id].variazioniCorrelate, k);  
                this.$set(this.dict[r.id].variazioniCorrelate, k, this.dict[r.id].backupDict[k]);   
                this.$delete(this.dict[r.id].backupDict, k);
            });
            if(this.dict[r.id].statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDaBC){
                this.$delete(this.dict, r.id);         
                this.$set(this.dict, r.id, this.righeEliminateBackupDict[r.id]);   
                this.$delete(this.righeEliminateBackupDict, r.id);
            }         
        }
    }

    private eliminaRiga(r: RigaInValidazione) {
       if (this.dict.hasOwnProperty(r.id)) {
           let rigaDaEliminare : any = {};
           Object.assign(rigaDaEliminare , this.dict[r.id]);
           this.$set(this.righeEliminateBackupDict, r.id, rigaDaEliminare);
           this.dict[r.id]._accettata = true;
           this.dict[r.id].statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDaBC;        
       }
    }

    isDeleted(v: RigaInValidazione): boolean {
        if (this.dict.hasOwnProperty(v.id)) {
            return this.dict[v.id].statoValidazione == StatoVariazioneRigaDistinta.RigaEliminataDaBC
        }
        return false;
    }

    contieneModificheCorrelate(v: VariazioneDaComunicare): boolean {
        return v.variazioniCorrelate.some((correlata: VariazioneDaComunicare) => {
        return correlata.tipoVariazione == TipoVariazione.NUOVA
            || (v.tipoVariazione != TipoVariazione.NUOVA && this.isVariazioneModified(correlata))
            || (v.tipoVariazione != TipoVariazione.NUOVA && this.isVariazioneDeleted(correlata));
        });
    }

    contieneValidazioniCorrelate(riga : RigaInValidazione){
        return Object.keys(this.dict[riga.id].variazioniCorrelate).some(k => this.dict[riga.id].variazioniCorrelate[k]._accettata);
    }
    isVariazioneModified(variazione: VariazioneDaComunicare): boolean {
        return variazione.variazioneRigaDistintaQtaTaglia.some(
        (variazione: VariazioneDaComunicareQtaTaglia) =>
            variazione.qta != variazione.qtaModificata
        );
    }

    isVariazioneDeleted(variazione: VariazioneDaComunicare): boolean {
        return variazione.tipoVariazione == TipoVariazione.ELIMINATA;
    }

    private async inviaVariazioniConfermate() {
        const variazioniDaComunicare: ComunicazioneVariazioneRigaDistinta[] = [];

        Object.keys(this.dict).forEach(key => {
            let v: VariazioneRigaDistinta = this.dict[key];
            if(v._accettata) {
                let c: ComunicazioneVariazioneRigaDistinta = {
                    idFornitore: v.idFornitore,
                    idDistinta: store.state.distintaCorrente ? store.state.distintaCorrente.id : '',
                    idRigaDistinta: key,
                    idUtente: v.idUtente,
                    quantitaPerTaglia: v.quantitaPerTagliaComunicate,
                    statoVariazione: v.statoValidazione
                };

                if (c.statoVariazione == StatoVariazioneRigaDistinta.RigaAggiuntaDaBC) {
                    let nuovaRiga = this.nuoveRighe.find((n : VariazioneDaComunicare) => n.rigaDistinta.id == key);
                    if(nuovaRiga) {
                        c.nuovaRigaDistinta = nuovaRiga.rigaDistinta;
                        // gestione correlate per comunicazione massiva... invio correlate nuove o modificate/cancellate nel caso la master non sia nuova
                        nuovaRiga.variazioniCorrelate.forEach((correlata: VariazioneDaComunicare) => {
                            if(!this.isVariazioneDeleted(correlata)){
                                let corr : ComunicazioneVariazioneRigaDistinta = {                                
                                    idFornitore: store.state.currentUsr.idFornitore,
                                    idDistinta: correlata.rigaDistinta.innerRigaDistinta.idDistinta,
                                    idRigaDistinta: correlata.rigaDistinta.id,
                                    idUtente: store.state.currentUsr.userName,
                                    quantitaPerTaglia: [], 
                                    statoVariazione: StatoVariazioneRigaDistinta.RigaAggiuntaDaBC
                                }; 
                                correlata.variazioneRigaDistintaQtaTaglia.forEach(qta => {
                                    corr.quantitaPerTaglia.push(qta.qtaModificata);                                
                                });
                                corr.nuovaRigaDistinta = correlata.rigaDistinta;
                                variazioniDaComunicare.push(corr);
                            }
                        });
                    }
                }                
                variazioniDaComunicare.push(c);
            }
            Object.keys(v.variazioniCorrelate).forEach( k => {
                    let varCorr = v.variazioniCorrelate[k];
                    if(varCorr._accettata){
                        let comCorr: ComunicazioneVariazioneRigaDistinta = {
                            idFornitore: varCorr.idFornitore,
                            idDistinta: varCorr.idDistintaAppartenenza,
                            idRigaDistinta: k,
                            idUtente: varCorr.idUtente,
                            quantitaPerTaglia: varCorr.quantitaPerTagliaComunicate,
                            statoVariazione: varCorr.statoValidazione
                        };
                        variazioniDaComunicare.push(comCorr);
                    }
                });
        });
        
        if(this.distinta){
            let risultato = await store.dispatch(StoreActions.ComunicaConfermeVariazioniRigheDistinteDPC, {variazioniConfermate:variazioniDaComunicare, idDistinta: this.distinta.id});
        }
    }
    private mostraCorrelate(riga: RigaInValidazione){        
        return (this.isDeleted(riga) || riga.righeCorrelate.some(r => r.contieneVariazioniDaValidare)) && riga.righeCorrelate.some(r => !r.inAttesaDiSincronizzazione);
    }
    private async consolidaDistinta() {
        if(this.distinta) {
            await store.dispatch(StoreActions.ConsolidaVariazioniDistintaStatica, this.distinta.id);
        }
    }
    private canEditRiga(riga: RigaInValidazione){
        return !(riga.inAttesaDiSincronizzazione || this.isDeleted(riga) || 
            Object.keys(this.dict[riga.id].variazioniCorrelate).some(k => this.dict[riga.id].variazioniCorrelate[k]._accettata));
    }
    private openDialog(){
        //non si può prendere come template la quantitaPerTaglia della prima riga perchè spesso ha più taglie inutili
        //quindi per ora prendo l'ultima
        if(this.altreRighe.length>0)
        {
            this.dialog.updateQtaPerTagliaTemplate(this.altreRighe[this.altreRighe.length-1]?.quantitaPerTaglia || []);
            this.dialog.open(); 
        }
    }
    private onRigaCreata(variazione: VariazioneDaComunicare) {          
        variazione.rigaDistinta.indiceRiga =
        Math.max(
            ...this.righeConVariazioni.map((v: RigaInValidazione) => v.indiceRiga),
            ...this.altreRighe.map((v: RigaInValidazione) => v.indiceRiga),            
        ) + 1;

        this.nuoveRighe.push(variazione);

        if(this.distinta){
            let v: VariazioneRigaDistinta  = {  
                backupDict: {},   
                mostraCorrelate: false,
                idDistintaAppartenenza: store.state.distintaCorrente ? store.state.distintaCorrente.id : '',
                indice: 0,
                idFornitore: store.state.currentUsr.idFornitore,
                idUtente: store.state.currentUsr.userName,
                dataComunicazione: new Date(),
                quantitaPerTagliaPreComunicazione: [],
                quantitaPerTagliaComunicate: [],
                variazioniCorrelate: [],
                statoValidazione: StatoVariazioneRigaDistinta.RigaAggiuntaDaBC,
                _accettata: true
            };
                            
            variazione.variazioneRigaDistintaQtaTaglia.forEach(qta => {
                v.quantitaPerTagliaPreComunicazione.push(qta.qtaModificata);
                v.quantitaPerTagliaComunicate.push(qta.qtaModificata);
            });
            this.$set(this.dict, variazione.rigaDistinta.id, v);
        }
    }    

    private eliminaNuovaRiga(v : VariazioneDaComunicare){
        if (this.dict.hasOwnProperty(v.rigaDistinta.id)) {
            this.nuoveRighe = this.nuoveRighe.filter(r => r.rigaDistinta.id != v.rigaDistinta.id);
            this.$delete(this.dict, v.rigaDistinta.id);            
        }
    }

    @Watch("$store.state.distintaCorrente", { immediate: true })
    async onDistintaChanged(distintaNuova: Distinta | undefined) {
      
      //this.variazioniInviabili = [];
      this.righeInValidazione = [];

      if(distintaNuova) {
          distintaNuova.righeDistintaDPC.forEach(riga => {
              let r : RigaInValidazione = {
                  id: riga.id,
                  idDistintaAppartenenza: distintaNuova.id,
                  indiceRiga: riga.indiceRiga,
                  innerRigaDistinta: riga.innerRigaDistinta,
                  coloreDecodificato: riga.coloreDecodificato,
                  faseDecodificata: riga.faseDecodificata,
                  indiceVariazioneAttiva: riga.indiceVariazioneAttiva,
                  contieneVariazioniDaValidare: riga.contieneVariazioniDaValidare,
                  variazioneGenerataDaValidazione: riga.variazioneGenerataDaValidazione,
                  inAttesaDiSincronizzazione: riga.inAttesaDiSincronizzazione,
                  conVariazioniConsolidate: riga.conVariazioniConsolidate,
                  richiestaDiInserimento: riga.richiestaDiInserimento,
                  righeCorrelate: this.caricaRigheCorrelate(distintaNuova.id, distintaNuova.idModello, 
                                        riga.innerRigaDistinta.idComponenteBga,
                                        riga.innerRigaDistinta.posizRiga),
                  mostraCorrelate: false,  
                  eliminataDaAs400: riga.eliminataDaAs400,                 
                  statoSincronizzazioneVariazione: riga.statoSincronizzazioneVariazione,
                  variazioniComunicate: riga.variazioniComunicate,
                  quantitaPerTaglia: [],
              };                                                        

              if(riga.quantitaPerTaglia) {
                let v: VariazioneRigaDistinta = {    
                    backupDict: {},
                    mostraCorrelate: false,
                    idDistintaAppartenenza: store.state.distintaCorrente ? store.state.distintaCorrente.id : '',
                    indice: 0,
                    idFornitore: store.state.currentUsr.idFornitore,
                    idUtente: store.state.currentUsr.userName,
                    dataComunicazione: new Date(),
                    quantitaPerTagliaPreComunicazione: [],
                    quantitaPerTagliaComunicate: [],
                    variazioniCorrelate: {},
                    statoValidazione: StatoVariazioneRigaDistinta.RigaModificataDaBC,
                    _accettata: false
                };

                r.righeCorrelate.forEach(riga => v.variazioniCorrelate[riga.id] = this.caricaVariazioneCorrelata(riga));

                if(riga.variazioniComunicate && riga.variazioniComunicate.length > 0) {
                    v.indice = Math.max(...riga.variazioniComunicate.map(x => x.indice)) + 1;
                    if(riga.contieneVariazioniDaValidare){                        
                        v.statoValidazione = riga.variazioniComunicate[v.indice-2].statoValidazione
                    }
                }
                riga.quantitaPerTaglia.forEach(qta => {
                    v.quantitaPerTagliaPreComunicazione.push(qta.qta);
                    v.quantitaPerTagliaComunicate.push(qta.qta);
                    if(r.quantitaPerTaglia) r.quantitaPerTaglia.push(qta);
                });
                this.righeInValidazione.push(r);
                this.$set(this.dict, riga.id, v);
              }
          });
      }
   }
    caricaRigheCorrelate(idDistinta: string, idModelloRiferimento: string, idComponente: string, posizRiga: string): RigaInValidazione[] {
        let correlate: RigaInValidazione[] = [];
        
        let distinteCorrelate = store.state.uiConsumi.listaDistinteCorrelate;
        
        distinteCorrelate.forEach((distinta: Distinta) => {
            let rigaCorrelata = distinta.righeDistintaDPC.find((riga: RigaDistinta) => 
                riga.innerRigaDistinta.idComponenteBga == idComponente && 
                riga.innerRigaDistinta.posizRiga == posizRiga);
            if(distinta.id != idDistinta && rigaCorrelata && this.isRigaModificabile(rigaCorrelata)) {
                let r : RigaInValidazione = {
                    id: rigaCorrelata.id,
                    eliminataDaAs400: rigaCorrelata.eliminataDaAs400,
                    idDistintaAppartenenza: distinta.id,
                    indiceRiga: rigaCorrelata.indiceRiga,
                    innerRigaDistinta: rigaCorrelata.innerRigaDistinta,
                    coloreDecodificato: rigaCorrelata.coloreDecodificato,
                    faseDecodificata: rigaCorrelata.faseDecodificata,
                    indiceVariazioneAttiva: rigaCorrelata.indiceVariazioneAttiva,
                    contieneVariazioniDaValidare: rigaCorrelata.contieneVariazioniDaValidare,
                    variazioneGenerataDaValidazione: rigaCorrelata.variazioneGenerataDaValidazione,
                    inAttesaDiSincronizzazione: rigaCorrelata.inAttesaDiSincronizzazione,
                    conVariazioniConsolidate: rigaCorrelata.conVariazioniConsolidate,
                    richiestaDiInserimento: rigaCorrelata.richiestaDiInserimento,
                    righeCorrelate: [],
                    mostraCorrelate: false,                   
                    statoSincronizzazioneVariazione: rigaCorrelata.statoSincronizzazioneVariazione,
                    variazioniComunicate: rigaCorrelata.variazioniComunicate,
                    quantitaPerTaglia: [],
                };        
                
                if(rigaCorrelata.quantitaPerTaglia){
                    rigaCorrelata.quantitaPerTaglia.forEach(qta => {
                        let q : RigaDistintaQtaTaglia = {
                            indice: qta.indice,
                            qta: qta.qta,
                            desc: qta.desc
                        }
                        if(r.quantitaPerTaglia)r.quantitaPerTaglia.push(q);
                    });
                }
                correlate.push(r);
            }
        });

        return correlate;
    }
    caricaVariazioneCorrelata(riga : RigaInValidazione) : any{                
        if(riga.quantitaPerTaglia){
            let v: VariazioneRigaDistinta  = {
                backupDict: {},
                mostraCorrelate: false,
                idDistintaAppartenenza: riga.idDistintaAppartenenza,
                indice: 0,
                idFornitore: store.state.currentUsr.idFornitore,
                idUtente: store.state.currentUsr.userName,
                dataComunicazione: new Date(),
                quantitaPerTagliaPreComunicazione: [],
                quantitaPerTagliaComunicate: [],
                variazioniCorrelate:{},
                statoValidazione: StatoVariazioneRigaDistinta.RigaModificataDaBC,
                _accettata: false
            };
            if(riga.variazioniComunicate && riga.variazioniComunicate.length > 0) {
                v.indice = Math.max(...riga.variazioniComunicate.map(x => x.indice)) + 1;
                if(riga.contieneVariazioniDaValidare){                        
                    v.statoValidazione = riga.variazioniComunicate[v.indice-2].statoValidazione
                }
            }
            riga.quantitaPerTaglia.forEach(qta => {
                v.quantitaPerTagliaPreComunicazione.push(qta.qta);
                v.quantitaPerTagliaComunicate.push(qta.qta);
            });

            return v;
        }
        return {};
    }
    isRigaModificabile(riga: RigaDistinta): boolean {
    
        if (riga.statoSincronizzazioneVariazione != StatoSyncRigaDistinta.STATO_SINCRONIZZAZIONE_VARIAZIONE_COMUNICATA_AD_AS400_MANUALMENTE)
        return true;

        if(!riga.variazioniComunicate)
        return false;

        let max = Math.max(...riga.variazioniComunicate.map(va => va.indice));
        let lastVariation = riga.variazioniComunicate.find(v => v.indice == max);
        if(!lastVariation)
        return false;

        return lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaAggiuntaDaBC &&
        lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaEliminataDaBC;
    }
}
